import { render, staticRenderFns } from "./Velg.vue?vue&type=template&id=5ba14c2c&"
import script from "./Velg.vue?vue&type=script&lang=js&"
export * from "./Velg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports